/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Ashish Singh, Created Date: 29-August-2023
</summary>
*/
import { getEffectiveDateForSchedule } from "../../constants/common-constants";
import { IAddReleaseScheduler } from "../../models/Form/IAddUpdateReleaseScheduler";

export const initialValues: IAddReleaseScheduler = {
  IsUpdateNow: "0",
  ScheduleDate:getEffectiveDateForSchedule(),
  Description: "",
  WantToUpdateDevices: "false",
  IsAppliedOnGroup: "true",
  GroupIds: [],
  ICCIDs: [],
  ICCIDsFile:"",
  ICCIDsFileContent:"",
};